"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import IndustryAgentPage from "./IndustryAgentPage";
import { logisticsIndustry } from "@/content/industries/logistics";

export default function IndustryLogistics({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <IndustryAgentPage page={logisticsIndustry} locale={locale} />;
}
